import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 80px 20px 0;
  font-family: "Roboto";

  @media (max-width: 500px) {
    padding: 20px 20px;
  }
`;

export const Content = styled.div`
  max-width: 1160px;
  margin: 120px auto;

  > h1 {
    color: #111;
    text-align: center;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    margin-bottom: 48px;
  }

  > div {
    > * {
      margin-top: 24px;
    }

    p {
      color: #2d2d2d;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
    }

    p.title-section {
      font-weight: 700;
    }

    > ul {
      padding-left: 16px;

      li + li {
        margin-top: 16px;
      }

      li {
        list-style: disc;
      }
    }
  }
`;
